<script lang="ts">
    import { onMount } from 'svelte';

    import { themeType as ThemeTypeEnum } from '../constants/Enums';
    import { isLogin, loadingReward } from '../store';

    import PhoneInput from './PhoneInput.svelte';
    import PhoneInputNew from './PhoneInputNew.svelte';

    export let themeType: ThemeTypeEnum = ThemeTypeEnum.WHITE;
    /** 新链路（introA-1/introB-1）：使用 PhoneInputNew，布局仍由 PhoneModule 提供 */
    export let useNewInput = false;

    // 登录态样式：仅黑色去掉外背景；白色保留外背景，只调顶部 padding
    let wrapperBgClass = '';

    $: bgClass =
        themeType === ThemeTypeEnum.BLACK ? 'bg-black' : 'bg-white';
    $: wrapperBgClass =
        $isLogin && themeType === ThemeTypeEnum.BLACK ? '' : bgClass;
</script>
{#if !$loadingReward}
<div
    class={`phone-module ${wrapperBgClass} `}
    class:phone-module--unlogin-black={themeType === ThemeTypeEnum.BLACK}
    class:phone-module--logged-black={themeType === ThemeTypeEnum.BLACK}
    style={themeType === ThemeTypeEnum.BLACK && $isLogin ? 'position: relative;top: -1.42rem;' : ''}
>
    {#if !$isLogin}
        {#if themeType === ThemeTypeEnum.WHITE}
            <div class="title">Ingresa tu número de celular</div>
        {:else}
            <div class="title-black">Ingresa tu número de celular</div>
        {/if}
    {/if}
    {#if useNewInput}
        <PhoneInputNew {themeType} />
    {:else}
        <PhoneInput {themeType} />
    {/if}
</div>
{/if}

<style lang="scss">
    .phone-module {
        .title {
            margin: 60px 0 0 40px;
            font-family: DiDiSans-Pro-Bold;
            font-size: 32px;
            letter-spacing: 0px;
            color: #000000;
        }
        .title-black {
            font-family: DiDiSans-Pro-Bold;
            font-size: 32px;
            letter-spacing: 0px;
            color: #f9f6fc;
            text-align: center;
        }
    }

    // 只在 PhoneModule 登录态触发：黑色按钮贴顶

    .phone-module--unlogin-black {
        position: relative;
        top: -102px;
    }

    .bg-white {
        background: #ffffff;
        color: #0b0b0d;
    }
    .bg-black {
        background: rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(122px);
        margin: 0 16px;
        min-height: 468px;
        border-radius: 32px;
        color: #ffffff;
        position: relative;
        padding: 40px 0px 0px 0px;
        z-index: 5;
    }
</style>
